import React, { memo, useState, useEffect, useRef, useCallback } from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ClearFiltersButton from '../ClearFiltersButton';

const FreeTextSearch = ({
  field,
  className,
  onChange,
  option,
  onReset,
  ...rest
}) => {
  const [tCommon] = useTranslation('common');

  const [text, setText] = useState('');
  const [isHideClear, setIsHideClear] = useState(false);

  useEffect(() => {
    setText(option.value);
  }, [option.value]);

  const timeout = useRef(null);
  const onTextChange = (e) => {
    const newText = e.target.value;
    setText(newText);

    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      onChange(field, newText, option);
    }, 200);
  };

  const clearValues = useCallback(() => {
    onReset(field, '', option);
    setText('');
  }, [field, onReset, option]);

  useEffect(() => {
    setIsHideClear(!text || text === '');
  }, [text]);

  return (
    <div className='filters__item'>
      <div className='filters__head'>
        <div className='filters__title'>{tCommon(option.label || field)}</div>
        {!isHideClear && (
          <ClearFiltersButton
            label={tCommon('labels.reset')}
            clearValues={clearValues}
          />
        )}
      </div>
      <div className='filters__body'>
        <TextField
          className='search-keyword'
          {...rest}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          onChange={onTextChange}
          value={text}
        />
      </div>
    </div>
  );
};

export default memo(FreeTextSearch);
